// extracted by mini-css-extract-plugin
export default {"actionIcon":"actionIcon---dutNS","button":"button---ojS_P"};